export default __webpack_public_path__ + "static/media/testimony2.2a907a5c.jpg";